import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["drawer", "backdrop"];

  connect() {
    document.addEventListener("keydown", this.keydownHandler);
    document.addEventListener("turbo:before-visit", this.closeHandler);
    document.addEventListener("turbo:before-cache", this.closeHandler);
  }

  disconnect() {
    this.unlockScroll();
    document.removeEventListener("keydown", this.keydownHandler);
    document.removeEventListener("turbo:before-visit", this.closeHandler);
    document.removeEventListener("turbo:before-cache", this.closeHandler);
  }

  get isOpen() {
    return (
      this.hasDrawerTarget &&
      !this.drawerTarget.classList.contains("translate-x-full")
    );
  }

  open() {
    if (this.isOpen) return;
    this.previouslyFocused = document.activeElement;
    this.drawerTarget.classList.remove("translate-x-full");
    this.backdropTarget.classList.remove("hidden");
    document.body.style.overflow = "hidden";
    const closeButton = this.drawerTarget.querySelector(
      "button[data-action*='close']",
    );
    if (closeButton) closeButton.focus();
  }

  close() {
    if (!this.isOpen) return;
    // Skip transition so Turbo's cache snapshot captures a clean state
    this.drawerTarget.style.transition = "none";
    this.drawerTarget.classList.add("translate-x-full");
    this.drawerTarget.offsetHeight; // force reflow
    this.drawerTarget.style.transition = "";
    this.backdropTarget.classList.add("hidden");
    this.unlockScroll();
    if (this.previouslyFocused) {
      this.previouslyFocused.focus();
      this.previouslyFocused = null;
    }
  }

  unlockScroll() {
    document.body.style.overflow = "";
  }

  keydownHandler = (event) => {
    if (event.key === "Escape") this.close();
    if (event.key === "Tab" && this.isOpen) this.trapFocus(event);
  };

  trapFocus(event) {
    const focusable = this.drawerTarget.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])',
    );
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  closeHandler = () => {
    this.close();
  };
}
